<template>
  <div class="banner">
    <img :src="src" />
  </div>
</template>

<script>
export default {
  props: {
    src: String,
  }
}
</script>

<style scoped>

  .banner {
    position: relative;

    display: flex;
  }

  .banner img {
    width: 100%;
    height: auto;

    flex: 0 0 100%;
  }

</style>